// extracted by mini-css-extract-plugin
export var growableInput = "_41-0";
export var tagContainer = "_41-2";
export var textInput = "_41-1";